import Reactor from '../reactor';

const STORE_LEARNING_CONTINUUM = 'STORE_LEARNING_CONTINUUM';

export default {
    STORE_LEARNING_CONTINUUM,

    storeLearningContinuum: (testkey, lcData) => {
        Reactor.dispatch(STORE_LEARNING_CONTINUUM, { testkey, lcData });
    },
};
